// 

$('.codecopy-loader').hide();
$(document).on('click', 'div.discount-code-snippet .discount-code', function(e) {
  e.preventDefault();
  var current = $(this).siblings('.discount-success-msg');
  var curr = $(this).children('span');
  var discount_code = $(this).data('id');
  var loaderclass = $(this).siblings('.codecopy-loader');
  $.ajax({
      url: `/discount/${discount_code}`,
      method: 'GET',
      beforeSend: function() {
          $(loaderclass).show();
          $(current).hide();
      },
      success: function() {
          $(loaderclass).hide();
          $(current).show();
          $(current).html('Copied');
          $(curr).removeClass('before-apply');
          $(curr).addClass('after-apply');

          setTimeout(function() {
            $(current).hide();
          }, 2000);
      }
  })
});


// Accordian
$(document).on('click','.cust-accordion .acco-title',function(e) {
  e.preventDefault();
  $(this).toggleClass('active').siblings('.acco-content').slideToggle(100);
})
const searchMobile = document.querySelector('.nav-container-action.custom');
if(searchMobile){
  $(document).on('click','.nav-container-action.custom',function(e) {
    e.preventDefault();
    $(this).toggleClass('active');
    $(this).parent().siblings('.mobile-search-toggle').toggleClass('active');
  })  
}

const ratingHeight = () =>  {
  let cacheHeight = 0;
  setTimeout(() => {
    let ele = document.querySelectorAll('.product-thumb-caption .product-thumb-caption-title');
    if(ele){
      ele.forEach(element => {
        (element.clientHeight > cacheHeight) ? cacheHeight = element.clientHeight : cacheHeight = cacheHeight;
      });
      ele.forEach(element => {
        element.style.height = `${cacheHeight}px`
      })
    }
  
  }, 1000);
 }

 const SliderLogo = () => {
  const slideView = $(".hero-logo-inner").attr('data-blocks-per-view');
  $('#slicklogos').slick({
		rows: 2,
    infinite: true,
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
		slidesToShow: slideView,
		slidesToScroll: 2,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  });
 }

 document.addEventListener('DOMContentLoaded', () => {
  ratingHeight();
  SliderLogo();
 })

window.el = {};
// open accordion by default on product page
window.el.pdpAccordionOpen = () => {
    $('details[data-open-default]').attr('open', 'open').find('summary').attr('aria-expanded', 'true');
}

// execute the scripts
$(document).ready(function () {
    window.el.pdpAccordionOpen();
    // sizeguide button toggle PDP
    $(document).on('click', '#sizeguideTrigger, #sizeguideTrigger-modal', function (e) {
        e.preventDefault();
        let sizeAcco = $('a[href="#sizeguide"]');
        let topOffsetSpacing = sizeAcco.offset().top - 50 - $('#top-header-section').height();
        $(sizeAcco).addClass('active').siblings('.acco-content').slideDown(200);

        $('html, body').animate({
            scrollTop: topOffsetSpacing
        }, 500)
    })
});


// $(document).on('click', '#add-to-cart-btn', async function() {
//   var form_id = $(this).data('id'),
//       variant_id = $(`#${form_id} [name="id"]`).val();
//   $.ajax({
//     type: 'POST',
//     url: '/cart/add.js',
//     dataType: 'json',
//     data: {
//       id: variant_id,
//       quantity: 1
//     },
//     success: function(res) {
//       window.location.href = '/cart';
//     }
//   })
// });

$(document).ready(function() {
  let checkoutBtn = document.querySelector('.discount_subtotal_inner');
  if (checkoutBtn && window.innerWidth <= 767) {
    let cloneCheckoutBtnEle = document.querySelector('.discount_subtotal_sticky');
    let checkoutBtnObserver = new IntersectionObserver( (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          cloneCheckoutBtnEle.classList.remove('active');
        } else {
          cloneCheckoutBtnEle.classList.add('active');
        }
      });
    })
    checkoutBtnObserver.observe(checkoutBtn);
  }
});

$(document).ready(function () {
  $('.variant-form').on('submit', function (e) {
    e.preventDefault();

    var form = $(this);

    $.ajax({
      type: form.attr('method'),
      url: form.attr('action'),
      data: form.serialize(),
      success: function (response) {
        // Update the current variant display
        var currentVariant = form.find('.variant-select option:selected').text();
        form.siblings('.current-variant').text(currentVariant);

        // You can also update other parts of the page if needed
      },
      error: function (error) {
        console.log('Error:', error);
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  // Use a common class to target all forms
    document.querySelectorAll('.ajax-form .products-grid.featured_product_submit').forEach(function(button) {
      // Check if the click event is already attached to the button
      if (!button.hasEventListener) {
          button.hasEventListener = true;  // Flag to indicate event attachment

          button.addEventListener('click', function(event) {
              event.preventDefault();
              var form = this.closest('form');
              var formData = new FormData(form);
              var productId = button.dataset.productId;
              const submitButton = document.querySelector('.btnsub-' + productId);
              cartNotification = document.querySelector('cart-notification'); // Ensure correct selector for cart-notification
              console.log(productId);
              submitButton.classList.add('loading');
              submitButton.setAttribute('aria-disabled', true);
              document.querySelector('.loading-overlay__spinner-' + productId).classList.remove('hidden');
              var modal = document.querySelector('#cart-notification');
              modal.style.display = 'block';
              document.querySelector('#cart-notification').classList.add('active');


              fetch('/cart/add.js', {
                  method: 'POST',
                  body: formData,
                  headers: {
                      'Accept': 'application/json',
                  },
              })
              .then(response => response.json())
              .then(data => {
                console.log(data);
                  // Handle the success response for this specific form.
                  var cartLinkBubble = document.querySelector('.cart-link__bubble');
                  var quantityExists = parseInt(cartLinkBubble.innerText, 10) || 0;
                  var newQty = quantityExists + 1;
                  console.log(newQty);
                  updateCartCount(newQty);
                  submitButton.classList.remove('loading');
                  document.querySelector('.loading-overlay__spinner-' + productId).classList.add('hidden');
                  displayProductDetailsModal(data,newQty);
                  // onSubmitHandler(productId);
                  setTimeout(() => {
                    const elementToClick = document.getElementById('closeCartPopup');
                    if (elementToClick) {
                      elementToClick.click();
                    }
                  }, 7000);
              })
              .catch((error) => {
                  // Handle errors for this specific form, e.g., show an error message.
                  console.error('Error:', error);
              });
          });
      }
    });

  function displayProductDetailsModal(productDetails,newQty) {
    console.log("productDetails",productDetails);
      // Update the content of the modal with the product details
      var modalContent = document.getElementById('cart-notification');
      modalContent.innerHTML = `<div class="main-cart-popup">
          <div class="cart-popup-wrapper">
              <div class="cart-popup-head">
                  <div class="svg-with-head-tag">
                      <span><svg class="icon icon-checkmark color-foreground-text" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 9" fill="none">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.35.643a.5.5 0 01.006.707l-6.77 6.886a.5.5 0 01-.719-.006L.638 4.845a.5.5 0 11.724-.69l2.872 3.011 6.41-6.517a.5.5 0 01.707-.006h-.001z" fill="currentColor"></path>
                        </svg>
                      </span>
                      <span>Item added to your cart</span>
                  </div>
                  <div class="close-cart-popup" id="closeCartPopup"> 
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" data-slot="icon" class="w-6 h-6">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                  </svg>
                  </div>
              </div>
              <div class="cart-popup-body">
                  <div class="cart-popup-product-img">
                      <img src="${productDetails.image}" alt="product-img">
                  </div>
                  <div class="product-content">
                      <h4 class="product-title">${productDetails.product_title}</h4>
                      <h4 class="product-quantity"><span class="option-title">Quantity:</span><span class="option-value">${productDetails.quantity}</span></h4>
                      ${productDetails.options_with_values ? 
                          productDetails.options_with_values
                              .filter(option => option.value !== 'Default Title')
                              .map(option => `
                                  <div class="product-option">
                                      <span class="option-title">${option.name}:</span><span class="option-value">${option.value}</span>
                                  </div>
                              `)
                              .join('') 
                          : ''
                      }
                  </div>
              </div>
              <div class="popup-button-wrapper">
                  <a href="/cart" class="btn primary-btn">View My Cart (${newQty})</a>
                  <button type="button" id="checkout2" onclick="handleFloCheckoutBtn()" class="cart-checkout-btn checkout-btn btn secondry-btn btn-lg" name="checkout2">Checkout
                  </button>
              </div>
              <button id="closeCartPopup" type="button" class="close-cart-popup">Continue shopping</button>
          </div>
      </div>
      `;
      closeCartPopup();
  }

  function closeCartPopup() {
    var closeCartPopup = document.querySelectorAll('#closeCartPopup');
      if (closeCartPopup) {
        closeCartPopup.forEach(function(cartPopup){
          cartPopup.addEventListener('click', function(event) {
            event.preventDefault();
              document.querySelector('#cart-notification').classList.remove('active');
          });
        });
      }
  }

  function updateCartCount(newQty) {
    console.log('dfasdsadas');
    var newCartCount = newQty;
    var qtyBoxs = document.querySelectorAll('.cart-link__bubble');
    qtyBoxs.forEach(function (qtyBox) {
      console.log(newCartCount);
      // qtyBox.innerText = newCartCount;
      qtyBox.innerText = newCartCount;
      console.log(qtyBox.innerText);
        });
}
  
});

if(window.innerWidth > 767){
  function handleScroll() {
    var navMobileContainer = document.querySelector('.mobile-hidden');
    var isNavStickyMob = navMobileContainer.classList.contains('nav-sticky');
  
    let bodyClassList = document.body.classList;
    if (isNavStickyMob) {
      bodyClassList.add('header-sticky');
    } else {
      bodyClassList.remove('header-sticky');
    }
  }
  
  window.addEventListener('scroll', handleScroll);
}

if(window.innerWidth < 767){
  function deskhandleScroll() {
    var navDeskContainer = document.querySelector('.desktop-hidden-sm');
    var isNavSticky = navDeskContainer.classList.contains('nav-sticky');

    let bodyClassList = document.body.classList;

    if (isNavSticky) {
      bodyClassList.add('header-sticky');
    } else {
      bodyClassList.remove('header-sticky');
    }
  }

  window.addEventListener('scroll', deskhandleScroll);
}